import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { createExecuteWorkflowAction, createLoadWorkflowRequestAction, getWorkflowActions, isWorkflowLoading } from "@multiweb/reactCore/datasource";
import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { LOC_KEY_WORKFLOW_ACTIONS } from "../../locKeys";
import { FrameSharedProps } from "../../types";
import { WorkflowButtonComponent, WorkflowButtonComponentProps } from "../WorkflowButtonComponent";

type StateProps = Pick<WorkflowButtonComponentProps, "title" | "workflowActions" | "isLoading">;
type DispatchProps = Pick<WorkflowButtonComponentProps, "executeAction" | "loadActions">;

const mapStateToProps: MapStateToProps<StateProps, FrameSharedProps, IAppState> = (state, { dataSourceKey }) => ({
    title: getPrimaryText(state, LOC_KEY_WORKFLOW_ACTIONS) ?? "",
    workflowActions: (getWorkflowActions())(state, dataSourceKey),
    isLoading: isWorkflowLoading(state, dataSourceKey),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, FrameSharedProps> = (dispatch, { dataSourceKey, recordId }) => ({
    executeAction: (workflowActionId: string) => dispatch(createExecuteWorkflowAction(dataSourceKey, workflowActionId, recordId)),
    loadActions: () => dispatch(createLoadWorkflowRequestAction(dataSourceKey, recordId)),
});

export const WorkflowButton = connect(mapStateToProps, mapDispatchToProps)(WorkflowButtonComponent);
